import type { ReactNode } from "react";
import type React from "react";
import styled from "styled-components";
import { PopupHoverContainer } from "@similarweb/ui-components";

type DescriptionPopupProps = {
    description: string;
    enabled?: boolean;
    children: ReactNode;
};

const ChildrenWrapper = styled.div`
    height: 100%;
`;

export const DescriptionPopup: React.FC<DescriptionPopupProps> = (props) => (
    <PopupHoverContainer
        content={() => <span>{props.description}</span>}
        config={{
            placement: "top",
            width: 360,
            cssClassContainer: "Popup-element-wrapper-triangle sidebar-website-header-popup-triangle",
            enabled: props.enabled,
        }}
    >
        <ChildrenWrapper>{props.children}</ChildrenWrapper>
    </PopupHoverContainer>
);
